// The status of the V1 farming-unit WRITE this page just dispatched
// (distributionActions.create_farming_unit / update_farming_unit report it only
// through `distribution_data.farming_unit_actions`; their thunks return
// nothing). This is the one `distribution_data` read in the New Season pages:
// it is the write's own init/success/fail flag, not data read from the V1
// fields/farming-units tables. All data comes from the V2 endpoints.
const { useSelector } = require('react-redux');

const useV1FarmingUnitWriteStatus = () =>
  useSelector((state) => state.distribution_data?.farming_unit_actions);

module.exports = { useV1FarmingUnitWriteStatus };
